export default "__VITE_ASSET__D0Uw4hsz__"